<template>
    <Card class="card" v-if="!user && !showAccessibility">
        <template #header>
            <!-- <img alt="user header" src="demo/images/usercard.png"> -->
        </template>
        <template #title>
            <div>Welcome to CNMP Platfrom</div>
            <div class="version">{{ version }}</div>
        </template>
        <template #content>
            <div class="p-fluid formgrid grid">
                <p v-if="registered.includes('Admin')" style="padding-left:10px;color:#449e48">Registration
                    Pending.
                    Please wait for EPD admin to approve.</p>
                <p v-else-if="registered.includes('Member')" style="padding-left:10px;color:#449e48">Registration
                    Pending.
                    Please wait for your company admin to approve.</p>
                <p v-else-if="notActive && !waitingEPD" style="padding-left:10px;color:#449e48">Registration Pending.
                    Please wait for your company admin to approve.</p>
                <p v-else-if="notActive && waitingEPD" style="padding-left:10px;color:#449e48">Registration
                    Pending.
                    Please wait for EPD admin to approve.</p>
                <div class="field col-12 md:col-12">
                    <span class="p-float-label input p-input-icon-left">
                        <i class="pi pi-user" />
                        <InputText id="username" type="text" v-model="username" />
                        <label for="username">Username</label>
                    </span>
                </div>
                <div class="field col-12 md:col-12">
                    <span class="p-float-label input p-input-icon-left">
                        <i class="pi pi-lock" style="z-index: 1;" />
                        <Password v-model="password" :feedback="false" toggle-mask class="password" />
                        <label for="password">Password</label>
                    </span>
                </div>
                <div v-if="attempFailed > 0 && attempFailed < 5" class="p-error"
                    style="padding-left:10px;text-align: left;">Incorrect
                    username or
                    password. <br>Warning: After 5 consecutive unsuccessful login attempts,
                    your account will be locked for 1 day. Attempts remaining: {{ 5 - attempFailed }}</div>
                <div v-if="attempFailed >= 5" class="p-error" style="padding-left:10px;text-align: left;">Your account
                    has
                    reached the
                    maximum numnber of failed login attempts and has been temporarily locked. Please try again tomorrow
                    or
                    reset your password.</div>
                <div v-if="incorrectCredencials" class="p-error" style="padding-left:10px">Username does not
                    exist.</div>
                <div style="width:100%;text-align: right;">
                    <Button label="Forgot password?" link @click="resetOnClick()" style="color: #2A652C" />
                </div>
            </div>
        </template>
        <template #footer>
            <div>
                <div class="footer">
                    <Button label="Register" class="p-button-secondary"
                        style="margin-left: .5em; background-color: #4a5b69" @click='registerOnClick()' />
                    <Button label="Login" @click='loginOnClick()' :icon="loading" iconPos="right"
                        style="background-color: #2A652C" />
                </div>
                <Button class="p-button-raised p-button-text" style="margin-top: 10px;padding:0"
                    @click="openAccessibility" v-tooltip.bottom="'Accessibility'" aria-label="Sign Out"><img
                        src="img/digital accessibility.png" alt="digital accessibility" style="width:108px;" /></Button>
            </div>
        </template>
    </Card>
    <Card class="card" v-if="user?.userType == 'admin'">
        <template #title>
            <div>Admin Two Factor Code</div>
        </template>
        <template #content>
            <div class="p-fluid formgrid grid">
                <div class="field col-12 md:col-12" style="text-align:left">
                    A two factor code has been sent to your registered email:
                </div>
                <div class="field col-12 md:col-12">
                    {{ user?.email }}
                </div>
                <div class="field col-12 md:col-12" style="text-align:left">
                    Two factor code:
                </div>
            </div>
            <div class="p-fluid formgrid grid" style="height: 70px;">
                <div class="field col-12 md:col-2">
                    <InputNumber v-model="twoFactor1" class="two-factor" :min="0" :max="9" inputId="twoFactor1"
                        @input="() => focus('twoFactor2')" @focus="twoFactor1 = undefined" />
                </div>
                <div class="field col-12 md:col-2">
                    <InputNumber v-model="twoFactor2" class="two-factor" :min="0" :max="9" inputId="twoFactor2"
                        @input="() => focus('twoFactor3')" @focus="twoFactor2 = undefined" />
                </div>
                <div class="field col-12 md:col-2">
                    <InputNumber v-model="twoFactor3" class="two-factor" :min="0" :max="9" inputId="twoFactor3"
                        @input="() => focus('twoFactor4')" @focus="twoFactor3 = undefined" />
                </div>
                <div class="field col-12 md:col-2">
                    <InputNumber v-model="twoFactor4" class="two-factor" :min="0" :max="9" inputId="twoFactor4"
                        @input="() => focus('twoFactor5')" @focus="twoFactor4 = undefined" />
                </div>
                <div class="field col-12 md:col-2">
                    <InputNumber v-model="twoFactor5" class="two-factor" :min="0" :max="9" inputId="twoFactor5"
                        @input="() => focus('twoFactor6')" @focus="twoFactor5 = undefined" />
                </div>
                <div class="field col-12 md:col-2">
                    <InputNumber v-model="twoFactor6" class="two-factor" :min="0" :max="9" inputId="twoFactor6"
                        @focus="twoFactor6 = undefined" @input="submitTwoFactor" />
                </div>
            </div>
            <small v-if="invalidTwoFactor" class="p-error" style="padding-left:10px">Two factor code is invalid or
                expired.</small>
        </template>
        <template #footer>
            <div class="footer">
                <Button label="Back" class="p-button-secondary" style="margin-left: .5em" @click='backOnClick()' />
                <Button v-if="!reset" label="Submit" @click='submitTwoFactor()' :icon="submitting" iconPos="right"
                    id="submit" />
            </div>
        </template>
    </Card>
    <Card style="width:500px" v-if="showAccessibility">
        <template #title>
            Web Accessibility Non-conformance Statement
            <Button icon="pi pi-times" class="p-button-rounded p-button-secondary p-button-text"
                style="position:fixed;right:10px;width:20px;height:20px;padding:0px"
                @click="showAccessibility = false" />
        </template>
        <template #content>
            <div style="text-align: left;">
                <p>We are committed to ensuring that our website conforms to the World Wide Web Consortium (W3C)
                    Web Content
                    Accessibility Guidelines (WCAG) 2.1 Level AA requirements to the maximum extent possible.
                    However, as our
                    website contains colour digital maps, huge volume of map image data with dynamic and
                    complicated spatially
                    interrelated contents and advanced map related functions, it is impossible to incorporate
                    all Level AA
                    accessibility requirements such as to convey the map information without relying on colours,
                    provide text
                    descriptions for all map images and control map functions simply using keyboards.</p>
            </div>
        </template>
    </Card>
</template>

<script>
import CryptoHelper from '@/helper/CryptoHelper';
export default {
    name: 'Login',
    props: {
        hasAccount: Boolean,
        registered: String
    },
    data() {
        return {
            username: "",
            password: "",

            attempFailed: 0,
            incorrectCredencials: false,
            notActive: false,
            waitingEPD: false,

            loading: "",

            user: undefined,

            twoFactor1: undefined,
            twoFactor2: undefined,
            twoFactor3: undefined,
            twoFactor4: undefined,
            twoFactor5: undefined,
            twoFactor6: undefined,

            submitting: "",
            invalidTwoFactor: false,

            showAccessibility: false
        }
    },
    mounted() {
        console.log(this.registered);
    },
    methods: {
        registerOnClick() {
            this.$emit('registerOnClick', "", false);
        },
        loginOnClick() {
            let props = this;
            this.loading = "pi pi-spin pi-spinner";
            this.getUser(
                function (user) {
                    localStorage.setItem("epd-cnmp-user", CryptoHelper.Encrypt(JSON.stringify(user)))
                    props.$store.dispatch('login', {
                        user: user
                    });
                    if (user.userType == "admin") {
                        props.user = user;
                    }
                    else {
                        props.loading = "";
                        props.$router.replace({ path: '/Projects' });
                    }
                },
                function (user) {
                    if (user.attempts > 0) {
                        console.log("here")
                        props.attempFailed = user.attempts;
                        props.incorrectCredencials = false;
                    }
                    else {
                        console.log("b")
                        props.attempFailed = 0;
                        props.incorrectCredencials = true;
                    }
                    props.loading = "";
                },
                function (isAdmin) { props.notActive = true; props.waitingEPD = isAdmin; props.loading = ""; }
            );
            // setTimeout(function () {
            //     if (user) {
            //         props.$router.replace({ path: '/' });
            //     }
            //     else {
            //         props.incorrectCredencials = true;
            //     }
            //     props.loading = "";
            // }, 1000);
        },
        getUser(successCallback, failCallback, notActiveCallback) {
            let cipherPassword = CryptoHelper.Encrypt(this.password);
            this.axios
                .post(`${this.apiEndpoint}user/signin?username=${this.username}&password=${cipherPassword}`)
                .then(response => {
                    if (response.data.active) {
                        successCallback(response.data);
                    }
                    else {
                        notActiveCallback(response.data.userType.includes("Admin"));
                    }
                })
                .catch(error => { failCallback(error.response?.data) })
        },
        resetOnClick() {
            this.$router.replace({ path: '/Reset' });
        },
        focus(target) {
            document.getElementById(target).focus();
        },
        blur(target) {
            document.getElementById(target).blur();
        },
        submitTwoFactor() {
            this.blur('twoFactor6');
            let props = this;
            props.submitting = "pi pi-spin pi-spinner";
            if (!isNaN(this.twoFactor1) && !isNaN(this.twoFactor2) && !isNaN(this.twoFactor3) && !isNaN(this.twoFactor4) && !isNaN(this.twoFactor5) && !isNaN(this.twoFactor6)) {
                this.axios
                    .get(`${this.apiEndpoint}user/twofactor?guid=${this.user.guid}&code=${this.twoFactor1}${this.twoFactor2}${this.twoFactor3}${this.twoFactor4}${this.twoFactor5}${this.twoFactor6}`)
                    .then(response => {
                        props.$router.replace({ path: '/Admin' });
                        props.submitting = "";
                    })
                    .catch(error => {
                        props.invalidTwoFactor = true;
                        props.submitting = "";
                    })
            }
        },
        backOnClick() {
            this.user = undefined;
        },
        openAccessibility() {
            this.showAccessibility = true;
        }
    }
}
</script>
<style>
.card .p-card-footer {
    height: 80px !important;
    padding: 0 !important;
}
</style>
<style scoped>
.card {
    width: 430px;
}

.footer {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
}

.input {
    margin-top: 10px;
}

.password>>>input {
    padding-left: 2rem;
}

.p-button {
    width: 110px;
}

.version {
    font-size: 1.1rem;
    padding-top: 0.5rem;
    color: #595959;
}

.two-factor {
    height: 60px
}
</style>
<style>
.two-factor>input {
    font-size: 30px;
    text-align: center;
}
</style>